var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_vm._l((_vm.payments),function(payment){return _c('Row',{key:payment.id,attrs:{"payment":payment}})})],2)}
var staticRenderFns = []
export { render, staticRenderFns }